module.exports = __webpack_public_path__ + "static/media/logo-ncs.cf7f81da.svg";